import React, { useEffect, useRef, useState } from "react";
import Layoutfooter from "../layous/footer";
import LayoutHeader from "../layous/headers";
import BgImg from "../assets/images/bg/bg.png"
import { Link, useParams } from "react-router-dom";
import { getContent } from "../controllers/apicontroller";
import DOMPurify from 'dompurify'
import {
  ShowMore
} from '@re-dev/react-truncate'

import { formatThaiDate } from "../helps/functions";


const View = () => {
  let componentMounted = useRef(true);
  const [loaded, setLoaded] = useState(false)
  const [item, setItem] = useState(null)
  const pr = useParams()

  useEffect(() => {
    if (componentMounted.current) {
      init()
    }

    return () => {
      componentMounted.current = false;
    }
  }, [])
  const init = async () => {
    setLoaded(false)
    await fetchContent()
    setLoaded(true)

  }
  const fetchContent = async () => {
    const response = await getContent(pr.id)
    console.log('fetch content data : ', pr.id)
    if (response.status == 200) {
      const data = await response.json()
      console.log('fetch content data : ', data.data)
      setItem(data.data)
    }
  }

  const [line, setLine] = useState(1)
  const toggleLines = (e) => {
    setLine(10000)
  }

  return (
    <>
      <LayoutHeader />
      {(loaded && item) &&
        <>
          {/* Content Details */}
          <section className="header-title">
            <div className="container">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  {pr.type == 'ita' ?
                    <li class="breadcrumb-item"><a href="/"><strong>ประเมินคุณธรรมและความโปร่งใส</strong></a></li>
                    :
                    <li class="breadcrumb-item"><a href="/procurement">ข้อมูลการจัดซื้อจัดจ้าง</a></li>
                  }
                  <li class="breadcrumb-item active" aria-current="page">{item.subject}</li>
                </ol>
              </nav>
            </div>
          </section>
          <section id="item-list" style={{ backgroundImage: `url(${BgImg})`, backgroundPosition: "center center", backgroundSize: "cover", backgroundRepeat: "no-repeat" }}>
            <div className="container">
              <div className='text-start pb-4'>
                <h2 className='fw-bolder text-green  font-kanit'>{item.subject}</h2>
                <div className='w-75 hr-custom' style={{ height: "3px" }}></div>
              </div>
              <div className="text-start mb-2" id="ita-result">
                {pr.type == 'ita-procurement' && (
                <div className="text-end">{formatThaiDate(item.writing_date) }</div>
                )}
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.detail) }}></div>
                {/* <ShowMore lines={line} more={<button onClick={toggleLines} className="btn btn-outline-success d-block m-auto mt-3">Read More</button>}>
                  <div dangerouslySetInnerHTML={{ 
                          __html: item.detail.slice(0, 1000)
                  }}></div>
                </ShowMore> */}

              </div>
              <div className="mt-2 text-start">
                {item.documents.length > 0 ?
                  <ul className="dash-list">
                    {item.documents.map((doc, d) => (
                      <li key={d}><Link to={doc.original_url}>{doc.file_name}</Link></li>
                    ))}
                  </ul>
                  : null}
              </div>
            </div>
          </section>
        </>
      }
      {/* Content Details */}
      <Layoutfooter />
    </>
  )
}

export default View